module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAP//EIaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABIALAAAAAAgACAAAAXAoCSOZGmeaGpGbKS+awTMLgzLc17bKJ7rvBOO9aMFSUSWwgc8tgCsRoNp5LUgtBYVqgqIWo6fdrszBQLaIvTxFKfQbfXY3WMV1OI0tIyMLA54RXp8I3qBeVUrh4uJJUNEjAAMLT06EQICjFIslToOEQgJh1o9EmKfEQkDeKSlpjmTLAQERQpLhEgiRQYtBA85DrEvLnixEVJ7LF7DgQwMEEnKZzeBEdAynE6RuNSjR47V34oAulziK7nnQpTq7SkhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSW_S4.gif
// module id = Pk6A
// module chunks = 48